import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, HostListener, inject, input, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule, NzButtonType } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule, NzTableSortOrder } from 'ng-zorro-antd/table';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { DynamicFieldModel } from '../dynamic-field-model';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MinusSquareTwoTone, MinusOutline, DownCircleTwoTone, DownOutline, UpCircleTwoTone, UpOutline, UploadOutline,CloudUploadOutline,TrophyTwoTone,CloseSquareTwoTone,DownSquareTwoTone,DownloadOutline } from '@ant-design/icons-angular/icons';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import { LoadingService } from '../services/loading.service';
import { AuthService } from '../services/auth-service';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { ChangeDetectorRef } from '@angular/core';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { CapitalLetterPipe } from '../pipes/capital-letter.pipe';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { G2MiniAreaModule } from '@delon/chart/mini-area';
import { NzRateModule } from 'ng-zorro-antd/rate';


@Component({
  selector: 'app-dynamic-table',
  imports: [NzTagModule, NzDatePickerModule, NzImageModule, NzDropDownModule, NzToolTipModule, NzDividerModule, NzTableModule, CommonModule, FormsModule, NzSelectModule, NzInputModule, NzButtonModule, NzIconModule, CapitalLetterPipe,
    G2MiniAreaModule,NzRateModule],
  providers: [
    // Register the icons
    { provide: NZ_ICONS, useValue: [MinusSquareTwoTone, MinusOutline, DownCircleTwoTone, DownOutline, UpOutline, UpCircleTwoTone,UploadOutline,CloudUploadOutline,TrophyTwoTone,CloseSquareTwoTone,DownSquareTwoTone,DownloadOutline ] },
  ],
  templateUrl: './dynamic-table.component.html',
  styleUrl: './dynamic-table.component.scss'
})
export class DynamicTableComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input('schema') schema!: any;
  @Input('total') total!: number;
  @Input('data') listOfData!: any;
  @Input('modalfieldConfig') modalfieldConfig: DynamicFieldModel[];
  private readonly authService = inject(AuthService);

  private static readonly ACTION_TYPE_TO_PERMISSION_SUFFIX: { [type: string]: string } = {
    edit: 'edit',
    danger: 'delete',
    gen: 'edit'
  };
  filters: { [key: string]: any } = {};
  sortMap: { [key: string]: 'ascend' | 'descend' | null } = {};
  updatedSchema: any;
  sorts: { [key: string]: 1 | -1 | null } = {};
  _pageSize: number;
  _pageIndex: number;
  searchValue: any;
  @Output('changeEvent') changeEvent = new EventEmitter<{ [key: string]: any }>();
  @Output('actionEvent') actionEvent = new EventEmitter<{ [key: string]: any }>();
  private filterSubject = new Subject<void>(); // Subject for debouncing
  private subscription: Subscription;
  loading = false;
  sortOrder: NzTableSortOrder | null = null;
  x_scrollWidth: string;
  tableHeight: string;
  dateFormat = 'dd/MM/yyyy';
  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly cdr: ChangeDetectorRef) {
    this.calculateHeight();
  }
  @HostListener('window:resize')
  calculateHeight() {
    // Subtract heights of header, footer, padding, etc.
    const offset = 400;
    const height = window.innerHeight - offset; // adjust based on your layout
    console.log(height);
    if (height < 50) {
      let modOffset=250;
      this.tableHeight = `${window.innerHeight - modOffset}px`;
      console.log(this.tableHeight);

    }
    else {
      this.tableHeight = `${window.innerHeight - offset}px`;
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges) {

  }
  ngOnInit(): void {
    this.calculateHeight();
    console.log((this.schema.columns.map((x: any) => parseInt(x.width)) as Array<number>));
    //this.x_scrollWidth = '1400px';
    this.x_scrollWidth = `${(this.schema.columns.map((x: any) => parseInt(x.width)) as Array<number>).reduce((acc, curr) => acc + curr, 0)}px`;
    console.log(this.x_scrollWidth);

    this.sortMap = this.schema.columns.filter((x: any) => x.enableSort).reduce((acc: { [key: string]: string }, y: any) => {
      acc[y.key] = null;
      return acc;
    }, {});

    this.sorts = this.schema.columns.filter((x: any) => x.enableSort).reduce((acc: { [key: string]: string }, y: any) => {
      acc[y.key] = null;
      return acc;
    }, {});
    this.subscription = this.loadingService.isVisible$.subscribe(value => {
      this.loading = value;
    });

    this.filterSubject.pipe(debounceTime(500)).subscribe(() => {
      this.emitFilterChange();
    });
    this._pageSize = this.schema.pageSize;
    this._pageIndex = this.schema.pageIndex;
    this.filters = this.schema.columns.reduce((acc: { [key: string]: string }, x: any) => {
      acc[x.key] = null;
      return acc;
    }, {});

  }
  onEdit(data: any) {
    const clone = { ...data };
    console.log(clone);
    const modalRef: NzModalRef = this.modalService.create({
      nzTitle: 'Edit',
      nzContent: DynamicFormComponent,  // Use dynamic form component
      nzData: { fields: this.modalfieldConfig, data: clone },
      nzFooter: null,
      nzMaskClosable: false   // We'll add footer buttons manually
    });
    modalRef.updateConfig({
      nzFooter: [{
        label: 'Submit',
        type: 'primary',
        onClick: () => this.handleUpdate(modalRef)
      },
      {
        label: 'Cancel',
        onClick: () => this.handleCancel(modalRef)
      }

      ]
    });
  }

  onAdd() {
    const modalRef: NzModalRef = this.modalService.create({
      nzTitle: 'Create',
      nzContent: DynamicFormComponent,  // Use dynamic form component
      nzData: { fields: this.modalfieldConfig, data: null },
      nzFooter: null,
      nzMaskClosable: false   // We'll add footer buttons manually
    });
    modalRef.updateConfig({
      nzFooter: [{
        label: 'Submit',
        type: 'primary',
        onClick: () => this.handleSubmit(modalRef)
      },
      {
        label: 'Cancel',
        onClick: () => this.handleCancel(modalRef)
      }

      ]
    });
  }

  onDelete(data: any) {
    this.actionEvent.emit({ deleted_id: data.id });
  }

  onGenerateResult(data:any){
    this.actionEvent.emit({ generate_id: data.id });
  }

  onDownload(){
    this.changeEvent.emit({ "sorts": this.sorts, "type": 'download', filters: this.filters });
  }

  handleCancel(modalRef: NzModalRef): void {
    console.log('Modal closed without submission');
    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.expandedKeys = [];
    modalRef.destroy();  // Close the modal
  }

  // Handle Submit button action
  handleSubmit(modalRef: NzModalRef, index: number = -1): void {
    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {
      let data = component.form.value;
      this.actionEvent.emit(data);
      this._pageIndex = 1;
      this._pageSize = 10;
      this.sorts = {};
      this.filters = {};
      this.resetSort();
      modalRef.destroy();
    } else {
      component.form.markAllAsTouched();
    }
  }

  resetSort(): void {
    this.sortOrder = null;
  }

  handleUpdate(modalRef: NzModalRef, index: number = -1): void {

    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {
      let data = component.form.value;
      this.actionEvent.emit(data);
      this._pageIndex = 1;
      this._pageSize = 10;
      this.sorts = {};
      this.filters = {};
      this.resetSort();
      modalRef.destroy();
    } else {
      component.form.markAllAsTouched();
    }
  }

  onPageIndexChange(pageIndex: number): void {
    this.loading = true;
    this._pageIndex = pageIndex;
    this.listOfData = [];
    this.changeEvent.emit({ "sorts": this.sorts, "type": 'sort', filters: this.filters, pageIndex: this._pageIndex, pageSize: this._pageSize });
  }

  onPageSizeChange(pageSize: number): void {
    this.loading = true;
    this._pageSize = pageSize;
    this.listOfData = [];
    this.changeEvent.emit({ "sorts": this.sorts, "type": 'sort', filters: this.filters, pageIndex: this._pageIndex, pageSize: this._pageSize });
  }

  onDateRangeChange(value: Date[] | null, key: string): void {
    if (value && value.length == 2) {
      this.onFilterChange();
    }
    else {
      this.clearFilter(key);
    }
  }

  onDateChange(value: Date | null, key: string): void {
    if (value) {
      this.onFilterChange();
    }
    else {
      this.clearFilter(key);
    }
  }

  onFilterChange(): void {
    this.filterSubject.next();
  }

  private emitFilterChange(): void {
    this._pageIndex = 1;
    this.schema.pageSize = this._pageSize;
    this.changeEvent.emit({ "sorts": this.sorts, "type": 'sort', filters: this.filters, pageIndex: this._pageIndex, pageSize: this._pageSize });
    this.loading = true;
  }

  onSort(sort: { key: string; value: any }): void {
    console.log(sort);
    Object.keys(this.sortMap).forEach(key => {
      this.sortMap[key] = key === sort.key ? sort.value : null;
    });
    Object.keys(this.sortMap).forEach(key => {
      this.sorts[key] = this.sortMap[key] == null ? null : this.sortMap[key] === 'ascend' ? 1 : -1;
    });
    console.log(JSON.stringify(this.sortMap));
    this.changeEvent.emit({ "sorts": this.sorts, "type": 'sort', filters: this.filters, pageIndex: this._pageIndex, pageSize: this._pageSize });

  }

  getSerialNo(index: number): number {
    return (this._pageIndex - 1) * this._pageSize + index + 1;
  }
  canShowAdd(): boolean {
    if (!this.schema?.enableAdd) {
      return false;
    }
    return this.hasActionPermission('add');
  }
  canShowAddForHeader(): boolean {
    const underRowCountThreshold = this.schema?.enableAddForRowCount !== undefined
      ? this.total < this.schema.enableAddForRowCount
      : true;
    return underRowCountThreshold && this.canShowAdd();
  }
  canShowLabel(label: { type?: string; isEnable?: boolean }): boolean {
    if (!label?.isEnable) {
      return false;
    }
    const suffix = DynamicTableComponent.ACTION_TYPE_TO_PERMISSION_SUFFIX[label.type ?? ''];
    if (!suffix) {
      return true;
    }
    return this.hasActionPermission(suffix);
  }

  private hasActionPermission(suffix: string): boolean {
    const permissionKey = this.schema?.permissionKey;
    if (!permissionKey) {
      return true;
    }
    return this.authService.hasPermission([`${permissionKey}.${suffix}`]);
  }

  getButtonType(type: string | undefined): NzButtonType {
    const validTypes: NzButtonType[] = ['primary', 'default', 'dashed', 'link', 'text'];
    return validTypes.includes(type as NzButtonType) ? (type as NzButtonType) : 'default';
  }

  getSplit(key: string): string[] {
    return key.split('.')
  }

  getCellValue(row: any, column: string): string {

    if (!row[column.split('.')[0]]) return ''
    const result: string = column
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    return result
  }

  getFormValue(row: any, column: string): string {

    if (!row[column.split('.')[0]]) return ''
    const result: string = column
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    return result
  }

  getTagColor(value: string): string {
    if (value == 'published') return 'green';
    return 'default'; // Default color for unknown permissions
  }

  clearFilter(key: string) {
    this.filters[key] = null;
    this.onFilterChange(); // Manually trigger the change handler
    this.cdr.detectChanges(); // Optional: Force change detection if needed
  }
}
